import React from 'react'
import {api} from 'lib/url'
import DownloadFile from 'organization/DownloadFile'
import {useParams} from 'react-router-dom'

export default function DownloadAttendeeZoomLog() {
  const {file} = useParams<{file: string}>()
  const url = api(`/attendee_zoom_logs_export/${file}`)
  return <DownloadFile url={url} />
}
